// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2m_wH","footer":"ModalUpdate_footer__6D-Bn"};